module.exports = __webpack_public_path__ + "img/Colombian.fcb372d4.svg";